module.exports = __webpack_public_path__ + "static/media/juri_facil.a8190a9f.svg";